<template>
  <div
    class="tw-flex tw-items-center tw-py-6 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light tw-px-6"
  >
    <div
      class="tw-flex tw-items-center"
      :style="`width: ${columns[0].width}`"
    >
      {{ permitType.name }}
    </div>

    <div :style="`width: ${columns[1].width}`">
      {{ permitType.description }}
    </div>

    <div :style="`width: ${columns[2].width}`">
      {{ permitType.renewal_offset }} {{ $t('common.days') }}
    </div>

    <div :style="`width: ${columns[3].width}`">
      <i-badge
        :type="permitType.case_assessment ? 'success' : 'default'"
        class="tw-w-fit"
      >
        {{ permitType.case_assessment ? $t('common.values.yes') : $t('common.values.no') }}
      </i-badge>
    </div>


    <div :style="`width: ${columns[4].width}`">
      {{ permitType.documents.length }}
    </div>

    <div :style="`width: ${columns[5].width}`">
      {{ permitType.statuses.length }}
    </div>

    <div :style="`width: ${columns[6].width}`">
      <div
        class="tw-flex tw-items-center tw-gap-2"
      >
        <i-button
          type="white"
          is-icon
          @click="isEditPermitTypeDialogOpen = true"
        >
          <icon-edit />
        </i-button>
        <i-confirm-popover
          :cancel-text="$t('common.actions.cancel')"
          :submit-text="$t('common.actions.delete')"
          @submit="deletePermitType"
        >
          <template #reference>
            <i-button
              type="white"
              is-icon
              class="tw-text-primary"
              :is-loading="isDeleting"
            >
              <icon-trash />
            </i-button>
          </template>
          <template #content>
            <div>
              {{ $t('adm.permits.types.delete_types_dialog.confirm_text') }}
              {{ permitType.name }}
            </div>
          </template>
        </i-confirm-popover>
      </div>
    </div>
    <EditPermitTypeDialog
      :is-open="isEditPermitTypeDialogOpen"
      :status-id="permitType.id"
      @close="isEditPermitTypeDialogOpen = false"
    />
  </div>
</template>

<script>

import { getValidationError } from '@/helpers';
import EditPermitTypeDialog from '@/components/Administration/PermitManagement/PermitTypes/EditPermitTypeDialog.vue';

export default {
  name: 'PermitTypeListItem',
  components: { EditPermitTypeDialog },
  props: {
    permitType: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isEditPermitTypeDialogOpen: false,
      isDeleting: false,
    };
  },

  methods: {
    async deletePermitType() {
      this.isDeleting = true;
      try {
        await this.$store.dispatch('v2/admin/cms/permitManagement/permitTypes/deleteType', this.permitType.id);
      } catch (e) {
        this.$message.error({
          message: this.$capitalize(e.response.data.message),
          showClose: true,
        });
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
